import irisAPI from '@services/iris-api'

import { UserPermissions } from '@permissions/permissions.types'

export const getUserPermissions = () => {
  return irisAPI.get<UserPermissions>('/v1/user-permissions')
}
